import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip as BPTooltip } from '@blueprintjs/core';
import Styles from './Tooltip.module.scss';

const Tooltip = ({ children, tooltip, ...props }) => (
  <BPTooltip
    content={tooltip}
    className={Styles['tooltip']}
    popoverClassName={Styles['tooltip--content']}
    {...props}
  >
    {children ? children : <span className={Styles['tooltip--icon']}></span>}
  </BPTooltip>
);

Tooltip.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
};

export default Tooltip;
